import { Input, Label, ListBox, ListBoxItem, Select, TextField } from '@heroui/react';

import { FUNDING, JUDGEMENTS, SELECT_PLACEHOLDER } from '../../i18n/el';

/** Τα φίλτρα της μελέτης περίπτωσης πάνω στην υπάρχουσα κατάσταση περιήγησης. */
export default function FundingFilters({ state, setFilter, showRelevance = false }) {
    return (
        <fieldset className="rounded-xl border border-border p-4">
            <legend className="px-2 text-sm font-semibold">{FUNDING.filters}</legend>
            <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
                <TextField value={state.agency} onChange={(agency) => setFilter({ agency })}>
                    <Label>{FUNDING.agency}</Label>
                    <Input />
                </TextField>
                <TextField value={state.field} onChange={(field) => setFilter({ field })}>
                    <Label>{FUNDING.field}</Label>
                    <Input />
                </TextField>
                <TextField
                    value={state.deadlineBefore}
                    onChange={(deadlineBefore) => setFilter({ deadlineBefore })}
                >
                    <Label>{FUNDING.deadlineBefore}</Label>
                    <Input type="date" />
                </TextField>
                <TextField value={state.minAmount} onChange={(minAmount) => setFilter({ minAmount })}>
                    <Label>{FUNDING.minAmount}</Label>
                    <Input type="number" min="0" step="0.01" inputMode="decimal" />
                </TextField>
                <TextField value={state.eligible} onChange={(eligible) => setFilter({ eligible })}>
                    <Label>{FUNDING.eligible}</Label>
                    <Input />
                </TextField>
                {showRelevance && (
                    <Select placeholder={SELECT_PLACEHOLDER}
                        selectedKey={state.relevance || 'all'}
                        onSelectionChange={(key) => setFilter({
                            relevance: String(key) === 'all' ? '' : String(key)
                        })}
                    >
                        <Label>{FUNDING.relevance}</Label>
                        <Select.Trigger><Select.Value /></Select.Trigger>
                        <Select.Popover>
                            <ListBox>
                                <ListBoxItem id="all">{FUNDING.allRelevance}</ListBoxItem>
                                {Object.entries(JUDGEMENTS.relevance).map(([id, label]) => (
                                    <ListBoxItem key={id} id={id}>{label}</ListBoxItem>
                                ))}
                            </ListBox>
                        </Select.Popover>
                    </Select>
                )}
            </div>
        </fieldset>
    );
}
